// extracted by mini-css-extract-plugin
export default {"location-info-container":"LocationInfo_location-info-container__ypR0N","embedded-map":"LocationInfo_embedded-map__D5Lp+"};